'use client';

import { useJoinFormStore } from '@/stores/join-form-store/join-form-store';
import { deleteCookie } from 'cookies-next';
import { type Dispatch, type SetStateAction } from 'react';

import { Modal, ModalButton, BaseModalContent } from '@/components/modal';
import { INVITE_CODE_COOKIE, PROMO_TITLE_COOKIE, PROMO_ID_COOKIE, PROMO_TERMS_URL_COOKIE } from '@/constants';

type CartConflictModalProps = {
  isModalOpen: boolean;
  setIsModalOpen: Dispatch<SetStateAction<boolean>>;
};

export const CartConflictModal = ({
  isModalOpen = false,
  setIsModalOpen,
}: CartConflictModalProps) => {
  const { resetCart } = useJoinFormStore();

  function closeModal() {
    setIsModalOpen(false);
  }

  function openModal() {
    setIsModalOpen(true);
  }

  const clearCookies = () => {
    deleteCookie(PROMO_TITLE_COOKIE);
    deleteCookie(PROMO_TERMS_URL_COOKIE);
    deleteCookie(PROMO_ID_COOKIE);
    deleteCookie(INVITE_CODE_COOKIE);
  };

  const clearCart = () => {
    resetCart();
  };

  return (
    <Modal
      expandHeader
      heading="Before we continue"
      description="You’ve currently got a plan selected, that conflicts with your currently selected promotions. Please remove the promotion or clear your current cart to continue"
      isModalOpen={isModalOpen}
      openModal={openModal}
    >
      <BaseModalContent
        buttonComponent={
          <>
            <ModalButton
              variant="primary"
              onClick={() => {
                clearCart();
                closeModal();
              }}
            >
              Yes, clear cart.
            </ModalButton>

            <ModalButton
              variant="tertiary"
              onClick={() => {
                clearCookies();
                closeModal();
              }}
            >
              No, keep my cart items.
            </ModalButton>
          </>
        }
      />
    </Modal>
  );
};
